import { useLayoutEffect, useState, useEffect, useCallback } from "react";
import {
  NumberBox,
  SelectBox,
  Template,
  TextArea,
  TextBox,
} from "devextreme-react";
import DataGrid, {
  Column,
  HeaderFilter,
  Scrolling,
  SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import {
  DateFilter,
  DefaultDateFormat,
  Features,
  IconWithTooltip,
} from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useLocation } from "react-router-dom";
import "./../../../App.css";
import Modal from "react-modal";
import moment from "moment";
import {
  askConfirmation,
  showErrorMessage,
  showResponseMessage,
  showSuccessMessage,
} from "../../../helper/message";
import { vishwamApi } from "../../../apis/apiServices/VishwamApi";
import { subCategoryService } from "../../../apis/apiServices/SubCategory";
import DataSource from "devextreme/data/data_source";
import { assetLocationService } from "../../../apis/apiServices/AssetLocation";
import { GetWorkFlowForApprovalForAsset } from "../../../apis/apiServices/WorkFlow";

const now = new Date();
const year = now.getFullYear();
const month = now.getMonth() + 1;

export default function SaveAssetScrapRequestComponent(props) {
  const user = useSelector((state) => state.user.data);
  const location = useLocation();
  const [state, setState] = useState({
    isSavingAsDraft: false,
    isSending: false,
    isAssetSubmitted: false,
    fromDepartmentName: user?.userDepartmentName,
    requestDate: moment(DateFilter.CurrentDateTime)
      .format(DefaultDateFormat.MomentDisplayDateTime24AMPFormat)
      .toString(),
    fromUserId: location.state?.stateData?.fromUserId ?? user?.userId,
    workFlowCategoryId: location.state?.stateData?.workFlowId ?? 0,
    projectId: location.state?.stateData?.projectId ?? 0,
    locationName: location.state?.stateData?.locationName ?? "",
    subject: location.state?.stateData?.subject ?? "",
    note: location.state?.stateData?.note ?? "",
    requestNo: location.state?.stateData?.assetScrapRequestNo ?? "",
    isAddAssetScrapSubModalOpen: false,
    assetScrapId: location.state?.stateData?.id ?? 0,
    assetScrapSubId: 0,
    categoryId: 0,
    categoryName: "",
    subCategoryId: 0,
    subCategoryName: "",
    assetId: 0,
    assetSerialNo: "",
    scrapQty: 1,
    reason: "",
    assetScrapSubList: [],
  });
  const [assetScrapAttachment, setAssetScrapAttachment] = useState({
    fileName: "",
    fileUrl: "",
    fileType: "",
    fileSize: 0,
    fileData: "",
    uploadedTemporaryAssetScrapAttachmentLst:
      location.state?.stateData?.assetScrapAttachment ?? [],
  });
  const [assetScrapSubAttachment, setAssetScrapSubAttachment] = useState({
    fileName: "",
    fileUrl: "",
    fileType: "",
    fileSize: 0,
    fileData: "",
    uploadedTemporaryAssetScrapSubAttachmentLst: [],
  });
  const [errors, setErrors] = useState({
    workFlowCategoryValidation: "",
    projectValidation: "",
    subjectValidation: "",
    categoryValidation: "",
    assetSerialNoValidation: "",
    reasonValidation: "",
    qtyValidation: "",
  });
  const [workFlowCategoryDropdown, setWorkFlowCategoryDropdown] = useState([]);
  const [projectDropdown, setProjectDropdown] = useState([]);
  const [categoryDropdown, setCategoryDropdown] = useState([]);
  const [assetSerialDropdown, setAssetSerialDropdown] = useState([]);
  const [assetScrapApproversByWorkflow, setAssetScrapApproversByWorkflow] =
    useState([]);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `${
      state.assetScrapId === 0
        ? `New Asset Scrap Request`
        : `Edit Asset Scrap Request - ${state.requestNo}`
    }`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getAssetScrapWorkflowCategory();
      }, 0);
      setTimeout(async () => {
        await getProjectDropdown();
      }, 0);
      setTimeout(async () => {
        await getAssetScrapSubLst(state.assetScrapId);
      }, 0);
      setTimeout(async () => {
        await GetWorkFlowForApprovers(
          state.workFlowCategoryId,
          state.projectId
        );
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const GetWorkFlowForApprovers = async (workFlowCategoryId, projectId) => {
    try {
      let body = {
        formId: props.featurePermission.featureId,
        categoryId: workFlowCategoryId || 0,
        projectId: projectId || 0,
        departmentId: user?.userDepartmentId || 0,
      };
      if (
        body.formId > 0 &&
        body.categoryId > 0 &&
        body.projectId > 0 &&
        body.departmentId > 0
      ) {
        const response = await GetWorkFlowForApprovalForAsset(body);
        const stagesWithApprovers = response?.stages
          ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
          ?.map((stage) => ({
            actionTypeName: stage?.actionTypeName?.trim(),
            approvers: stage?.approvers,
          }));
        const Approvers = response?.stages
          ?.filter((stage) => stage?.approvers && stage?.approvers?.length > 0)
          ?.flatMap((stage) =>
            stage?.approvers?.map((approver) => ({
              actionTypeId: stage?.actionTypeId,
              userId: approver?.userId,
              canEdit: approver?.canEdit,
              stageId: stage?.index,
            }))
          );
        setAssetScrapApproversByWorkflow(stagesWithApprovers);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetScrapWorkflowCategory = async () => {
    try {
      const response = await assetService.getAssetRequestWorkflowCategory(
        Number(props.featurePermission.featureId)
      );
      setWorkFlowCategoryDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getProjectDropdown = async () => {
    try {
      //let body1 = { companyId: user?.companyId };
      //const response = await vishwamApi.getProjectList(body1);
      let body = { companyId: user?.companyId };
      const response = await vishwamApi.getProjectByUserId(user.userId, body);
      setProjectDropdown(response?.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategoryDropdown = async () => {
    try {
      const response = await subCategoryService.getSubCategoryList();
      setCategoryDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetScrapSubLst = async (assetScrapId) => {
    try {
      const response = await assetService.getAssetScrapSub(assetScrapId);
      setState((prev) => ({
        ...prev,
        assetScrapSubList: response?.data ?? [],
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetSerialNoDropdown = async (categoryId, subCategoryId) => {
    try {
      const response = await assetService.getAssetSerialNoDropdown(
        categoryId,
        subCategoryId
      );
      setAssetSerialDropdown(response?.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  const getAssetScrapBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) return resolve("");
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleAssetScrapFileChange = async (e) => {
    try {
      setAssetScrapAttachment((prev) => ({ ...prev, fileData: "" }));
      const assetScrapAttachment = Array.from(e.target.files);
      const newAttachmentPromises = assetScrapAttachment.map(async (file) => {
        const base64 = await getAssetScrapBase64(file);
        return {
          noOfRows: Math.random().toString(16).slice(2),
          id: 0,
          assetScrapId: state.assetScrapId,
          fileName: file.name,
          fileSize: file.size,
          filePath: "",
          fileUrl: "",
          fileData: base64,
          fileType: file.type,
          uploadDate: "",
        };
      });
      const newAttachments = await Promise.all(newAttachmentPromises);
      setAssetScrapAttachment((prev) => {
        const existingList =
          prev.uploadedTemporaryAssetScrapAttachmentLst || [];
        return {
          ...prev,
          uploadedTemporaryAssetScrapAttachmentLst: [
            ...existingList,
            ...newAttachments,
          ],
        };
      });
    } catch (error) {
      console.error(error);
    }
  };

  const getAssetScrapSubBase64 = (file) => {
    return new Promise((resolve, reject) => {
      if (!file) return resolve("");
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleAssetScrapSubFileChange = async (e) => {
    try {
      setAssetScrapSubAttachment((prev) => ({ ...prev, fileData: "" }));
      const assetScrapSubAttachment = Array.from(e.target.files);
      const newAttachmentPromises = assetScrapSubAttachment.map(
        async (file) => {
          const base64 = await getAssetScrapSubBase64(file);
          return {
            noOfRows: Math.random().toString(16).slice(2),
            id: 0,
            assetScrapSubId: state.assetScrapSubId,
            fileName: file.name,
            fileSize: file.size,
            filePath: "",
            fileUrl: "",
            fileData: base64,
            fileType: file.type,
            uploadDate: "",
          };
        }
      );
      const newAttachments = await Promise.all(newAttachmentPromises);
      setAssetScrapSubAttachment((prev) => {
        const existingList =
          prev.uploadedTemporaryAssetScrapSubAttachmentLst || [];
        return {
          ...prev,
          uploadedTemporaryAssetScrapSubAttachmentLst: [
            ...existingList,
            ...newAttachments,
          ],
        };
      });
    } catch (error) {
      console.error(error);
    }
  };

  const isValidAssetScrubSubData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.categoryValidation = "";
      err.assetSerialNoValidation = "";
      err.qtyValidation = "";
      err.reasonValidation = "";
      if (state.subCategoryId === 0) {
        err.categoryValidation = "Please select category.";
        isValid = false;
      }
      if (!state.assetSerialNo) {
        err.assetSerialNoValidation = "Please select asset serial #.";
        isValid = false;
      }
      if (!state.scrapQty || state.scrapQty === 0) {
        err.qtyValidation = "Please enter qty.";
        isValid = false;
      }
      if (!state.reason) {
        err.reasonValidation = "Please enter reason.";
        isValid = false;
      }
      setErrors(err);
    } catch (error) {
      console.error(error);
    }
    return isValid;
  };

  const handleOnAddAssetScrapSub = async (e) => {
    e.preventDefault();
    try {
      if (isValidAssetScrubSubData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to add asset?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isAssetSubmitted: true }));
        let assetScrapSubLst = [...state.assetScrapSubList];
        let assetScrapSubSourceLst = {};
        assetScrapSubSourceLst.noOfRows = Math.random().toString(16).slice(2);
        assetScrapSubSourceLst.id = state.assetScrapSubId;
        assetScrapSubSourceLst.assetScrapRequestId = state.assetScrapId;
        assetScrapSubSourceLst.categoryId = state.categoryId;
        assetScrapSubSourceLst.categoryName = state.categoryName;
        assetScrapSubSourceLst.subCategoryId = state.subCategoryId;
        assetScrapSubSourceLst.subCategoryName = state.subCategoryName;
        assetScrapSubSourceLst.assetId = state.assetId;
        assetScrapSubSourceLst.assetSerialNo = state.assetSerialNo;
        assetScrapSubSourceLst.qty = state.scrapQty;
        assetScrapSubSourceLst.scrapReason = state.reason;
        assetScrapSubSourceLst.statusId = 0;
        assetScrapSubSourceLst.modifiedBy = 0;
        assetScrapSubSourceLst.modifiedByUserName = "";
        assetScrapSubSourceLst.modifiedDate = "";
        assetScrapSubSourceLst.modifiedDateUtc = "";
        assetScrapSubSourceLst.assetScrapSubAttachment =
          assetScrapSubAttachment.uploadedTemporaryAssetScrapSubAttachmentLst ??
          [];
        if (state.assetScrapSubId > 0) {
          const index = assetScrapSubLst.findIndex(
            (item) =>
              (item.id && item.id === assetScrapSubSourceLst.id) ||
              (!item.id && item.noOfRows === assetScrapSubSourceLst.noOfRows)
          );
          if (index !== -1) {
            assetScrapSubLst[index] = assetScrapSubSourceLst;
          }
        } else {
          assetScrapSubLst.push(assetScrapSubSourceLst);
        }
        setState((prev) => ({
          ...prev,
          assetScrapSubList: assetScrapSubLst,
        }));
        handleOnCloseAddAssetScrapSubModal();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setState((prev) => ({ ...prev, isAssetSubmitted: false }));
    }
  };

  const isValidAssetScrapData = () => {
    let isValid = true;
    try {
      let err = { ...errors };
      err.projectValidation = "";
      err.subjectValidation = "";
      if (state.projectId === 0) {
        err.projectValidation = "Please select project.";
        isValid = false;
      }
      if (!state.subject) {
        err.qtyValidation = "Please enter subject.";
        isValid = false;
      }
      setErrors(err);
    } catch (error) {
      console.error(error);
    }
    return isValid;
  };

  const handleOnSaveAssetScrapRequest = async (e, isSent) => {
    e.preventDefault();
    try {
      if (state.assetScrapSubList?.length === 0) {
        await showErrorMessage(`Please add at least one asset!!`);
        return;
      }
      if (isValidAssetScrapData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to ${
          state.assetScrapId === 0 ? "add" : "update"
        } asset scrap?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSavingAsDraft: true }));
        let body = {
          requestNo: state.requestNo,
          assetScrapId: state.assetScrapId,
          fromId: state.fromUserId,
          requestedDate: moment(DateFilter.CurrentDateTime)
            .format(DefaultDateFormat.SqlDateTimeFullFormat)
            .toString(),
          projectId: state.projectId,
          subject: state.subject,
          note: state.note,
          modifiedBy: user?.userId,
          workFlowId: state.workFlowCategoryId,
          isSent: isSent,
          fromDepartmentId: user?.userDepartmentId,
          assetScrapAttachment:
            assetScrapAttachment.uploadedTemporaryAssetScrapAttachmentLst,
          assetScrapSub: state.assetScrapSubList,
          formId: props.featurePermission.featureId,
          formName: "Asset Scrap",
        };
        const response = await assetService.saveAssetScrapRequest(body);
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSavingAsDraft: false }));
        if (response?.isSuccess) {
          window.location.href = "/AssetScrap";
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSavingAsDraft: false }));
      console.error(error);
    }
  };

  const handleOnSendAssetScrapRequest = async (e, isSent) => {
    e.preventDefault();
    try {
      if (isValidAssetScrapData()) {
        let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to send asset scrap for approval?</span>`;
        let isConfirmed = await askConfirmation(
          confirmationQuestion,
          "Yes",
          "No"
        );
        if (!isConfirmed) return;
        setState((prev) => ({ ...prev, isSending: true }));
        let body = {
          requestNo: state.requestNo,
          assetScrapId: state.assetScrapId,
          fromId: state.fromUserId,
          requestedDate: moment(DateFilter.CurrentDateTime)
            .format(DefaultDateFormat.SqlDateTimeFullFormat)
            .toString(),
          projectId: state.projectId,
          subject: state.subject,
          note: state.note,
          modifiedBy: user?.userId,
          workFlowId: state.workFlowCategoryId,
          isSent: isSent,
          fromDepartmentId: user?.userDepartmentId,
          assetScrapAttachment:
            assetScrapAttachment.uploadedTemporaryAssetScrapAttachmentLst,
          assetScrapSub: state.assetScrapSubList,
          formName: "Asset Scrap",
        };
        const response = await assetService.saveAssetScrapRequest(body);
        isConfirmed = await showResponseMessage(response);
        setState((prev) => ({ ...prev, isSending: false }));
        if (response?.isSuccess) {
          window.location.href = "/AssetScrap";
        }
      }
    } catch (error) {
      setState((prev) => ({ ...prev, isSending: false }));
      console.error(error);
    }
  };

  const handleOnOpenAddAssetScrapSubModal = async (e, data) => {
    e.preventDefault();
    try {
      setState((prev) => ({
        ...prev,
        isAddAssetScrapSubModalOpen: true,
        assetScrapSubId: data?.id ?? 0,
        categoryId: data?.categoryId ?? 0,
        categoryName: data?.categoryName ?? "",
        subCategoryId: data?.subCategoryId ?? 0,
        subCategoryName: data?.subCategoryName ?? "",
        assetId: data?.assetId ?? 0,
        assetSerialNo: data?.assetSerialNo ?? "",
        scrapQty: data?.qty ?? 1,
        reason: data?.scrapReason ?? "",
      }));
      setAssetScrapSubAttachment((prev) => ({
        ...prev,
        uploadedTemporaryAssetScrapSubAttachmentLst:
          data?.assetScrapSubAttachment ?? [],
      }));
    } catch (error) {
      console.error(error);
    }
  };

  const handleOnCloseAddAssetScrapSubModal = () => {
    try {
      setState((prev) => ({
        ...prev,
        isAddAssetScrapSubModalOpen: false,
        categoryId: 0,
        categoryName: "",
        subCategoryId: 0,
        subCategoryName: "",
        assetId: 0,
        assetSerialNo: "",
        scrapQty: 1,
        reason: "",
        assetScrapSubId: 0,
      }));
      setAssetScrapSubAttachment((prev) => ({
        ...prev,
        uploadedTemporaryAssetScrapSubAttachmentLst: [],
      }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div
          className="card"
          style={{ borderRadius: "6px", marginTop: "-10px" }}
        >
          <div
            className="card-header p-2"
            style={{
              backgroundColor: "#e3e7ff",
              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px",
            }}
          >
            <div className="float-left">
              <h6 className="mb-0 mt-1">
                From&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {state.fromDepartmentName}
                </strong>
                &nbsp;&nbsp;&nbsp;&nbsp;Date&nbsp;-&nbsp;
                <strong style={{ color: "#282C7D" }}>
                  {state.requestDate}
                </strong>
              </h6>
            </div>
            <div className="float-right">
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={async (e) => {
                  window.location.href = "/AssetScrap";
                }}
              >
                <span title="Cancel ">
                  <i className="fas fa-times" />
                  &nbsp;&nbsp;Cancel
                </span>
              </button>
              &nbsp;&nbsp;
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={async (e) => {
                  await handleOnSaveAssetScrapRequest(e, false);
                }}
                disabled={state.isSavingAsDraft}
              >
                <span title="Save As Draft">
                  <i
                    className={`fas fa-${
                      state.isSavingAsDraft
                        ? "spinner fa-spin"
                        : "file-signature"
                    }`}
                  />
                  &nbsp;&nbsp;Save As Draft
                </span>
              </button>
              {state.assetScrapId > 0 && (
                <>
                  &nbsp;&nbsp;
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={async (e) => {
                      await handleOnSendAssetScrapRequest(e, true);
                    }}
                    disabled={state.isSending}
                  >
                    <span title="Send">
                      <i
                        className={`fas fa-${
                          state.isSending ? "spinner fa-spin" : "check"
                        }`}
                      />
                      &nbsp;&nbsp;Send for Approval
                    </span>
                  </button>
                </>
              )}
            </div>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    Project&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={projectDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select project"
                    name="projectDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.projectId}
                    defaultValue={state.projectId}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.projectValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        projectId: e?.selectedItem?.id ?? 0,
                        locationName: "",
                      }));
                      if (e?.selectedItem?.id > 0) {
                        const response =
                          await assetLocationService.getLocationList(
                            e?.selectedItem?.id
                          );
                        await GetWorkFlowForApprovers(
                          state.workFlowCategoryId,
                          e?.selectedItem?.id
                        );
                        setState((prev) => ({
                          ...prev,
                          locationName:
                            response?.data
                              ?.filter(
                                (f) => f.projectId === e?.selectedItem?.id
                              )
                              ?.map((a) => a.name)
                              .join(", ") ?? "",
                        }));
                      }
                    }}
                  />
                  {errors.projectValidation && (
                    <div className="text-danger">
                      {errors.projectValidation}
                    </div>
                  )}
                </div>
              </div>
              {state.locationName && (
                <>
                  <div className="col-12 col-lg-4">
                    <div className="form-group mb-2">
                      <label>Location</label>
                      <TextBox
                        className="form-control form-control-sm"
                        height={37}
                        readOnly={true}
                        value={state.locationName}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-12 col-lg-4">
                <div className="form-group mb-2">
                  <label>
                    Category&nbsp;<span className="text-danger">*</span>
                  </label>
                  <SelectBox
                    dataSource={workFlowCategoryDropdown}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    placeholder="Select category"
                    name="workFlowCategoryDropdown"
                    displayExpr="name"
                    valueExpr="id"
                    value={state.workFlowCategoryId}
                    defaultValue={state.workFlowCategoryId}
                    showClearButton={true}
                    disabled={false}
                    searchEnabled={true}
                    onSelectionChanged={async (e) => {
                      let err = { ...errors };
                      err.workFlowCategoryValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        workFlowCategoryId: e?.selectedItem?.id ?? 0,
                      }));
                      setAssetScrapApproversByWorkflow([]);
                      if (e?.selectedItem?.id > 0) {
                        await GetWorkFlowForApprovers(
                          e?.selectedItem?.id,
                          state.projectId
                        );
                      }
                    }}
                  />
                  {errors.workFlowCategoryValidation && (
                    <div className="text-danger">
                      {errors.workFlowCategoryValidation}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-lg-8">
                <div className="form-group mb-2">
                  <label>
                    Subject&nbsp;<span className="text-danger">*</span>
                  </label>
                  <TextBox
                    className="form-control form-control-sm"
                    height={37}
                    placeholder="Enter subject"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={state.subject}
                    onValueChanged={(e) => {
                      let err = { ...errors };
                      err.subjectValidation = "";
                      setErrors(err);
                      setState((prev) => ({
                        ...prev,
                        subject: e?.value,
                      }));
                    }}
                  />
                  {errors.subjectValidation && (
                    <div className="text-danger">
                      {errors.subjectValidation}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <DataGrid
                    dataSource={state.assetScrapSubList}
                    showBorders={true}
                    columnAutoWidth={true}
                    allowColumnResizing={true}
                    showRowLines={true}
                    showColumnLines={false}
                    height={250}
                    onToolbarPreparing={(e) => {
                      e.toolbarOptions.items.unshift({
                        location: "before",
                        template: "toolbarAddTemplate",
                      });
                    }}
                  >
                    <Column
                      dataField=""
                      caption=""
                      allowSorting={false}
                      allowSearch={false}
                      allowExporting={false}
                      allowFiltering={false}
                      width={50}
                      cellRender={(data) => {
                        const idPrefix = `icon-${
                          data?.data?.id === 0
                            ? data?.data?.noOfRows
                            : data?.data?.id
                        }`;
                        return (
                          <>
                            <div style={{ display: "flex" }}>
                              <span>
                                <IconWithTooltip
                                  id={`${idPrefix}-edit`}
                                  className="iconify-size mr-1"
                                  title="Edit Asset"
                                  tooltip="Edit Asset"
                                  icon="solar:pen-line-duotone"
                                  style={{ cursor: "pointer" }}
                                  onClick={async (e) => {
                                    await handleOnOpenAddAssetScrapSubModal(
                                      e,
                                      data?.data
                                    );
                                  }}
                                />
                              </span>
                              <span>
                                <IconWithTooltip
                                  id={`${idPrefix}-delete`}
                                  className="iconify-size mr-1"
                                  title="Delete"
                                  tooltip="Delete"
                                  icon="fluent:delete-32-regular"
                                  style={{ cursor: "pointer" }}
                                  onClick={async (e) => {
                                    e.preventDefault();
                                    try {
                                      let confirmationQuestion = `<span style='font-size:16px;'>Are you sure want to delete asset ${data?.data?.assetSerialNo}?</span>`;
                                      let isConfirmed = await askConfirmation(
                                        confirmationQuestion,
                                        "Yes",
                                        "No"
                                      );
                                      if (!isConfirmed) return;
                                      if (data?.data?.noOfRows) {
                                        setState((prev) => ({
                                          ...prev,
                                          assetScrapSubList:
                                            state.assetScrapSubList?.filter(
                                              (f) =>
                                                f.noOfRows !==
                                                data?.data?.noOfRows
                                            ),
                                        }));
                                        isConfirmed = await showSuccessMessage(
                                          `Asset ${data?.data?.assetSerialNo} is deleted successfully!!`
                                        );
                                      } else if (data.data?.id > 0) {
                                        const response =
                                          await assetService.deleteAssetScrapSub(
                                            data?.data?.id
                                          );
                                        isConfirmed = await showResponseMessage(
                                          response
                                        );
                                        if (response?.isSuccess) {
                                          await getAssetScrapSubLst(
                                            data?.data?.assetScrapRequestId
                                          );
                                        }
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                />
                              </span>
                            </div>
                          </>
                        );
                      }}
                    />
                    <Column
                      dataField="assetSerialNo"
                      caption="Asset Description"
                      allowSearch={true}
                      allowSorting={true}
                      cellRender={(data) => {
                        return (
                          <>
                            <span>{data?.data?.assetSerialNo ?? ""}</span>
                            {data?.data?.categoryName &&
                              data?.data?.subCategoryName && (
                                <>
                                  <br />
                                  <div
                                    style={{
                                      color: "#b1b1b1",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {data?.data?.categoryName}
                                    {"  >  "}
                                    {data?.data?.subCategoryName}
                                  </div>
                                </>
                              )}
                          </>
                        );
                      }}
                    />
                    <Column
                      dataField="scrapReason"
                      caption="Reason"
                      allowSearch={true}
                      allowSorting={true}
                    />
                    <Column
                      dataField="qty"
                      caption="Qty"
                      allowSearch={true}
                      allowSorting={true}
                      alignment={"center"}
                    />
                    <Column
                      dataField="assetScrapSubAttachment"
                      caption="Attachments"
                      alignment={"center"}
                      allowSorting={false}
                      allowSearch={false}
                      allowExporting={false}
                      allowFiltering={false}
                      cellRender={(cellData) => {
                        const attachments =
                          cellData.data.assetScrapSubAttachment || [];
                        if (!attachments.length) return <span>No Files</span>;
                        return (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                marginBottom: 4,
                                textAlign: "center",
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "6px",
                              }}
                              title={attachments
                                .map((a) => a.fileName)
                                .join(", ")}
                              onClick={() => {}}
                            >
                              {attachments.map((file, index) => (
                                <>
                                  <a
                                    key={index}
                                    href={file.fileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ cursor: "pointer", color: "blue" }}
                                    title={file.fileName}
                                  >
                                    {file.fileName}
                                  </a>
                                  {index < attachments.length - 1 && ", "}
                                </>
                              ))}
                            </div>
                            {cellData?.data?.id === 0 && (
                              <>
                                <div
                                  style={{
                                    display: "flex",
                                    gap: 10,
                                    justifyContent: "center",
                                  }}
                                >
                                  <>
                                    {attachments.map((a, index) => (
                                      <img
                                        key={index}
                                        src={a.fileData}
                                        alt={a.fileName}
                                        title={a.fileName}
                                        style={{
                                          width: 50,
                                          height: 50,
                                          objectFit: "cover",
                                          borderRadius: 4,
                                          border: "1px solid #ddd",
                                        }}
                                      />
                                    ))}
                                  </>
                                </div>
                              </>
                            )}
                          </div>
                        );
                      }}
                    />
                    <Template
                      name="toolbarAddTemplate"
                      render={() => {
                        return (
                          <>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={() => {
                                setState((prev) => ({
                                  ...prev,
                                  isAddAssetScrapSubModalOpen: true,
                                }));
                              }}
                            >
                              <span title="Add Asset">
                                <i className="fas fa-plus" />
                                &nbsp;&nbsp;Add Asset
                              </span>
                            </button>
                          </>
                        );
                      }}
                    />
                    <HeaderFilter visible={false} />
                    <Scrolling mode="virtual" />
                    <SearchPanel
                      visible={true}
                      highlightCaseSensitive={true}
                      width={240}
                      placeholder="Search..."
                    />
                  </DataGrid>
                </div>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <label
                    htmlFor="fileScrapUpload"
                    className="btn btn-outline-primary mb-1"
                    style={{ cursor: "pointer" }}
                    title="Attachment"
                  >
                    <i class="fas fa-plus"></i>&nbsp;Attachment
                  </label>
                  <input
                    id="fileScrapUpload"
                    type="file"
                    style={{ display: "none" }}
                    onChange={async (e) => {
                      await handleAssetScrapFileChange(e);
                    }}
                  />
                </div>
                <div className="attachment-container">
                  {assetScrapAttachment?.uploadedTemporaryAssetScrapAttachmentLst?.map(
                    (file, idx) => (
                      <div key={idx} className="attachment-item">
                        <div
                          class="d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                        >
                          <div
                            className="attachment-name"
                            onClick={() => {
                              if (file?.filePath) {
                                window.open(file?.fileUrl, "_blank");
                              }
                            }}
                          >
                            {file?.fileName}
                          </div>
                          {file?.id === 0 && (
                            <button
                              className="btn pt-0 pb-0 pr-0"
                              onClick={() => {
                                setAssetScrapAttachment((prev) => ({
                                  ...prev,
                                  uploadedTemporaryAssetScrapAttachmentLst:
                                    assetScrapAttachment.uploadedTemporaryAssetScrapAttachmentLst?.filter(
                                      (_, i) => i !== idx
                                    ),
                                }));
                              }}
                            >
                              <i class="fas fa-times"></i>
                            </button>
                          )}
                        </div>
                        <div className="small">
                          {(file?.fileSize / 1024).toFixed(0)} kb
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
            {/* <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group mb-2">
                  <label>Note</label>
                  <TextArea
                    className="form-control form-control-sm"
                    placeholder="Enter note"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={state.note}
                    onValueChanged={(e) => {
                      setState((prev) => ({
                        ...prev,
                        note: e.value,
                      }));
                    }}
                  />
                </div>
              </div>
            </div> */}
            <div className="row">
              <div className="col-lg-4 col-md-12 col-sm-4">
                <div className="form-group">
                  <label>Prepared By</label>
                  {state?.assetScrapId > 0 ? (
                    <TextBox
                      className="form-control"
                      placeholder="Enter name"
                      showClearButton={false}
                      value={
                        location?.state?.stateData?.fromUserName +
                        " (" +
                        location?.state?.stateData?.fromDesignationName +
                        ")"
                      }
                      readOnly={true}
                    />
                  ) : (
                    <TextBox
                      className="form-control"
                      placeholder="Enter name"
                      showClearButton={false}
                      value={
                        user?.firstName +
                        " " +
                        user?.lastName +
                        " (" +
                        user?.userDesignationName +
                        ")"
                      }
                      readOnly={true}
                    />
                  )}
                </div>
              </div>
              {assetScrapApproversByWorkflow?.map((stage, index) => (
                <div
                  key={index}
                  className="col-lg-4 col-md-12 col-sm-4 d-flex align-items-start"
                >
                  <div className="w-100">
                    <label className="form-label">
                      {stage?.actionTypeName}
                    </label>
                    {stage?.approvers?.map((approver, i) => (
                      <input
                        key={i}
                        type="text"
                        className="form-control"
                        value={`${approver?.userName} (${approver?.designationName})`}
                        readOnly
                      />
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* For Adding Asset */}
      <Modal
        ariaHideApp={false}
        isOpen={state.isAddAssetScrapSubModalOpen}
        onAfterOpen={async () => {
          await getCategoryDropdown();
          await getAssetSerialNoDropdown(state.categoryId, state.subCategoryId);
          let err = { ...errors };
          err.categoryValidation = "";
          err.assetSerialNoValidation = "";
          err.reasonValidation = "";
          err.qtyValidation = "";
          setErrors(err);
        }}
        className={"react-modal custom-modal-large"}
        shouldCloseOnOverlayClick={false}
        contentLabel="Add/Edit Asset"
      >
        <div className="modal-header">
          <h6 className="modal-title">Add Asset</h6>
          <button
            type="button"
            className="close"
            onClick={() => {
              handleOnCloseAddAssetScrapSubModal();
            }}
          >
            <span aria-hidden="true">x</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>
                  Category&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={
                    new DataSource({
                      store: {
                        type: "array",
                        data: categoryDropdown,
                        key: "id",
                      },
                      group: "categoryName",
                    })
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select category"
                  name="categoryDropdown"
                  displayExpr="name"
                  valueExpr="id"
                  showClearButton={true}
                  searchEnabled={true}
                  defaultValue={state.subCategoryId}
                  value={state.subCategoryId}
                  grouped={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.categoryValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      subCategoryId: e?.selectedItem?.id ?? 0,
                      categoryId: e?.selectedItem?.categoryId ?? 0,
                      subCategoryName: e?.selectedItem?.name ?? "",
                      categoryName: e?.selectedItem?.categoryName ?? "",
                      assetId: 0,
                      assetSerialNo: "",
                    }));
                    setAssetSerialDropdown([]);
                    if (
                      e?.selectedItem?.id > 0 &&
                      e?.selectedItem?.categoryId > 0
                    ) {
                      await getAssetSerialNoDropdown(
                        e?.selectedItem?.categoryId,
                        e?.selectedItem?.id
                      );
                    }
                  }}
                />
                {errors.categoryValidation && (
                  <div className="text-danger">{errors.categoryValidation}</div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="form-group mb-2">
                <label>
                  Asset Serial #&nbsp;<span className="text-danger">*</span>
                </label>
                <SelectBox
                  dataSource={assetSerialDropdown}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder="Select asset serial #"
                  name="assetSerialDropdown"
                  displayExpr="code"
                  valueExpr="code"
                  value={state.assetSerialNo}
                  defaultValue={state.assetSerialNo}
                  showClearButton={true}
                  disabled={false}
                  searchEnabled={true}
                  onSelectionChanged={async (e) => {
                    let err = { ...errors };
                    err.assetSerialNoValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      assetSerialNo: e?.selectedItem?.code ?? "",
                      assetId: e?.selectedItem?.id ?? 0,
                    }));
                  }}
                />
                {errors.assetSerialNoValidation && (
                  <div className="text-danger">
                    {errors.assetSerialNoValidation}
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 col-lg-4">
              <div className="from-group mb-2">
                <label>
                  Scrap Qty&nbsp;<span className="text-danger">*</span>
                </label>
                <NumberBox
                  name="scrapQty"
                  height={37}
                  className="form-control form-control-sm"
                  readOnly={true}
                  placeholder="Enter scrap qty"
                  showClearButton={true}
                  valueChangeEvent="keyup"
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.qtyValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      scrapQty: e.value ?? 0,
                    }));
                  }}
                  value={Number(state.scrapQty ?? 0) || ""}
                />
                {errors.qtyValidation && (
                  <div className="text-danger">{errors.qtyValidation}</div>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <label>
                  Reason&nbsp;<span className="text-danger">*</span>
                </label>
                <TextArea
                  className="form-control form-control-sm"
                  placeholder="Enter reason"
                  name="reason"
                  showClearButton={true}
                  valueChangeEvent="keyup"
                  value={state.reason}
                  onValueChanged={(e) => {
                    let err = { ...errors };
                    err.reasonValidation = "";
                    setErrors(err);
                    setState((prev) => ({
                      ...prev,
                      reason: e.value,
                    }));
                  }}
                />
                {errors.reasonValidation && (
                  <div className="text-danger">{errors.reasonValidation}</div>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-lg-12">
              <div className="form-group mb-2">
                <label
                  htmlFor="fileScrapSubUpload"
                  className="btn btn-outline-primary mb-1"
                  style={{ cursor: "pointer" }}
                  title="Attachment"
                >
                  <i class="fas fa-plus"></i>&nbsp;Attachment
                </label>
                <input
                  id="fileScrapSubUpload"
                  type="file"
                  style={{ display: "none" }}
                  onChange={async (e) => {
                    await handleAssetScrapSubFileChange(e);
                  }}
                />
              </div>
              <div className="attachment-container">
                {assetScrapSubAttachment?.uploadedTemporaryAssetScrapSubAttachmentLst?.map(
                  (file, idx) => (
                    <div key={idx} className="attachment-item">
                      <div
                        class="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className="attachment-name"
                          onClick={() => {
                            if (file?.filePath) {
                              window.open(file?.fileUrl, "_blank");
                            }
                          }}
                        >
                          {file?.fileName}
                        </div>
                        {file?.id === 0 && (
                          <button
                            className="btn pt-0 pb-0 pr-0"
                            onClick={() => {
                              setAssetScrapSubAttachment((prev) => ({
                                ...prev,
                                uploadedTemporaryAssetScrapSubAttachmentLst:
                                  assetScrapSubAttachment.uploadedTemporaryAssetScrapSubAttachmentLst?.filter(
                                    (_, i) => i !== idx
                                  ),
                              }));
                            }}
                          >
                            <i class="fas fa-times"></i>
                          </button>
                        )}
                      </div>
                      <div className="small">
                        {(file?.fileSize / 1024).toFixed(0)} kb
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm"
            title="Cancel"
            onClick={() => {
              handleOnCloseAddAssetScrapSubModal();
            }}
          >
            <i className="fas fa-times"></i>&nbsp;&nbsp;Cancel
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={async (e) => {
              await handleOnAddAssetScrapSub(e);
            }}
            disabled={state.isAssetSubmitted}
          >
            <span title="Submit">
              <i
                className={`fas fa-${
                  state.isAssetSubmitted ? "spinner fa-spin" : "check"
                }`}
              />
              &nbsp;&nbsp;Submit
            </span>
          </button>
        </div>
      </Modal>
    </>
  );
}
